import React, { useEffect, useState } from "react";
import { skillLevelList } from "../lib/TemplatesData";

const RatingPicker = ({ getLevel, levelLabel, skillEnabled }) => {

  const skillLevelListIndex = skillLevelList.findIndex(item => item.label === levelLabel)
  const levels = skillLevelList;
  const [skillLevelIndex] = useState(skillEnabled ? skillLevelListIndex !== -1 ? skillLevelListIndex : 0 : 0)
  const [isSkillExperience, setIsSkillExperience] = useState(skillEnabled)


  const [level, setLevel] = useState({
    color: skillEnabled ? levels[skillLevelIndex].color : 'bg-gray-500',
    label: levels[skillLevelIndex].label,
    fadedColor: skillEnabled ? levels[skillLevelIndex].fadedColor : 'bg-gray-200',
    borderColor: skillEnabled ? levels[skillLevelIndex].borderColor : 'border-gray-400',
    hoverColor: levels[skillLevelIndex].hoverColor,
    textColor: skillEnabled ? levels[skillLevelIndex].textColor : 'text-black',
    index: skillLevelIndex,
  });


  // useEffect(() => {

  // }, [level.label]);

  useEffect(() => {

    setLevel({
      color: skillEnabled ? levels[skillLevelIndex].color : 'bg-gray-500',
      label: levels[skillLevelIndex].label,
      fadedColor: skillEnabled ? levels[skillLevelIndex].fadedColor : 'bg-gray-200',
      borderColor: skillEnabled ? levels[skillLevelIndex].borderColor : 'border-gray-400',
      hoverColor: levels[skillLevelIndex].hoverColor,
      textColor: skillEnabled ? levels[skillLevelIndex].textColor : 'text-black',
      index: skillLevelIndex,
    })

    setIsSkillExperience(skillEnabled)

  }, [skillEnabled,skillLevelIndex,levels])

  const onLevelClick = (item, index) => {
    const { color, label, fadedColor, borderColor, textColor, hoverColor } = item;
    setLevel({
      color,
      label,
      fadedColor,
      index,
      borderColor,
      textColor,
      hoverColor
    });
    getLevel(label);
  };

  const handleSkillLevelValue = (e, label) => {
    setIsSkillExperience(e.target?.checked)
    setLevel({
      color: e.target?.checked ? levels[skillLevelIndex].color : 'bg-gray-500',
      label: levels[skillLevelIndex].label,
      fadedColor: e.target?.checked ? levels[skillLevelIndex].fadedColor : 'bg-gray-200',
      borderColor: e.target?.checked ? levels[skillLevelIndex].borderColor : 'border-gray-400',
      hoverColor: levels[skillLevelIndex].hoverColor,
      textColor: e.target?.checked ? levels[skillLevelIndex].textColor : 'text-black',
      index: skillLevelIndex,
    })
    if (e.target?.checked) {
      getLevel(label)
    } else {
      getLevel("")
    }

  }
  return (
    <div className="my-1">
      <div className="flex justify-between items-center">
        <div className="flex">
          <label className="block text-sm font-medium text-gray-700">
            Level: 
          </label>
          
          <p className={`${level.textColor} block text-sm font-semibold`}>
            {level.label}
          </p>
        </div>
        <div>
          {skillEnabled && <label class="flex items-center cursor-pointer">
            <input type="checkbox" class="sr-only peer" checked={isSkillExperience} onClick={(e) => handleSkillLevelValue(e, level.label)} />
            <div class="relative w-7 h-[15px] md:w-9 md:h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 md:after:h-4 md:after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>}
        </div>
      </div>

      <div
        className={`mt-1 cursor-pointer w-full border border-gray-300 rounded-lg shadow-sm h-[63%] md:h-[65%] flex relative ${level.fadedColor}`}
      >
        {levels.map((item, index) => {
          const {
            color,
            index: levelIndex,
            borderColor,
            hoverColor
          } = level;
          return (
            <div className={`w-full flex`} key={index}>
              <div
                className={`w-full ${levelIndex === index ? `${color} rounded-lg` : `${skillEnabled ? hoverColor : ''}`
                  } hover:rounded-lg`}
                onClick={() => skillEnabled && onLevelClick(item, index)}
                style={{
                  transition: "all 0.5s ease", // Transition for smooth effect
                  backgroundColor: levelIndex === index ? color : "",
                }}
              ></div>
              {index !== levels.length - 1 && (
                <div
                  className={`${levelIndex !== index && levelIndex - 1 !== index
                    ? `border-r-2 ${borderColor}`
                    : ``
                    } h-1/4 my-auto`}
                  style={{ transition: "all 0.5s ease" }} // Transition for smooth effect
                ></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingPicker;